import { ISelectMultipleOption } from "@/main/components/shared/selectMultipleOutlined/selectMultipleOutlined";
import { QuoteSupplierItemPartResponse } from "@/main/models/response";
import { QuoteProcurementPartInfoResponse } from "@/main/models/response/quoteResponse";

export interface IGroupedRowItem {
	item: QuoteSupplierItemPartResponse;
	originalIndex: number;
}

export interface IPartTypeOption {
	idPartType: number;
	partTypeName: string;
}

export interface IGroupedRow {
	groupKey: string;
	rows: IGroupedRowItem[];
	partTypeOptions: IPartTypeOption[];
	quoteProcurementPartInfo: QuoteProcurementPartInfoResponse;
}

export function groupPendingItems(dataGrid: QuoteSupplierItemPartResponse[]): IGroupedRow[] {
	const groupMap = new Map<string, IGroupedRow>();
	const groupOrder: string[] = [];

	dataGrid.forEach((item, index) => {
		const quoteItemPartNumber = item.quoteProcurementPartInfo?.quoteItemPartNumber ?? "";
		const groupKey = `${item.guidQuoteItem}::${item.guidQuoteSupplier}::${quoteItemPartNumber}`;

		if (!groupMap.has(groupKey)) {
			groupOrder.push(groupKey);
			groupMap.set(groupKey, {
				groupKey,
				rows: [],
				partTypeOptions: [],
				quoteProcurementPartInfo: item.quoteProcurementPartInfo,
			});
		}

		const group = groupMap.get(groupKey)!;
		group.rows.push({ item, originalIndex: index });

		const alreadyHasPartType = group.partTypeOptions.some((pt) => pt.idPartType === item.idPartType);
		if (!alreadyHasPartType) {
			group.partTypeOptions.push({
				idPartType: item.idPartType,
				partTypeName: item.partTypeName,
			});
		}
	});

	return groupOrder.map((key) => groupMap.get(key)!);
}

export function getDisplayedGroupRows(
	group: IGroupedRow,
	selectedPartTypes: ISelectMultipleOption[],
): IGroupedRowItem[] {
	if (selectedPartTypes.length === 0) return group.rows.slice(0, 1);

	const selectedKeys = new Set(selectedPartTypes.map((option) => option.key));
	return group.rows.filter(({ item }) => selectedKeys.has(item.idPartType));
}
